import { create } from "zustand";

interface ColumnInfoState {
  columnsSchema: any;
  setColumnSchema: (schema: any) => void;
}

export const useColumnInfoStore = create<ColumnInfoState>((set) => ({
  columnsSchema: [],
  setColumnSchema: (schema) => set({ columnsSchema: schema }),
}));
